import { Link } from "react-router-dom";
import { FaInstagram, FaSpotify, FaYoutube, FaXTwitter, FaTiktok } from "react-icons/fa6";

const socials = [
  { label: "Instagram", href: "https://www.instagram.com/timbaland/", Icon: FaInstagram },
  { label: "Spotify", href: "https://open.spotify.com/artist/5Y5TRrQiqgUO4S36tzjIRZ", Icon: FaSpotify },
  { label: "YouTube", href: "http://www.youtube.com/@Timbaland", Icon: FaYoutube },
  { label: "X", href: "https://x.com/timbaland", Icon: FaXTwitter },
  { label: "TikTok", href: "https://www.tiktok.com/@timbaland", Icon: FaTiktok },
];

export default function Footer() {
  return (
    <footer className="bg-obsidian border-t border-white/10 py-16" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col items-center gap-8 mb-12">
          <div className="flex items-center">
            <img
              src="/timbo-green.png"
              alt="Timbo Da King"
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center gap-4">
            {socials.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`social-${label.toLowerCase()}`}
                className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white/60 hover:text-black hover:bg-gold hover:border-gold transition-all duration-300"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <p className="font-body text-white/40 text-sm">
            © {new Date().getFullYear()} Timbo Da King · The Official Archive. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="admin-link"
            className="font-display uppercase tracking-[0.2em] text-[0.68rem] text-white/30 hover:text-gold transition-colors"
          >
            Media Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
